export const ActionType = {
  ADD: 0,
  UPDATE: 1,
  VIEW: 2,
};
